import { lambdaCorrelationScope } from '#~/api/request-scope.js';
import type { Template } from '#~/device/registry/types.js';
import type { Model } from '@studio/models/device';
import type { T_Maybe } from '@tryiris-ai/js-types';

/** Subscribe to active-org scope used for registry cache keys. */
export const subscribeRegistryOrganizationScope = (listener: () => void): (() => void) =>
  lambdaCorrelationScope.subscribe(listener);

export const getRegistryOrganizationScope = (): string =>
  lambdaCorrelationScope.getOrganizationId();

/** Every server targeting input partitions cached responses, including partial scope. */
export const getRegistryRequestScope = (): string => lambdaCorrelationScope.getCacheScope();

/** One key format for reactive readers, request caches, and fixture writers. */
export const scopedTemplateKey = (scope: string, modelId: string): string => `${scope}:${modelId}`;

export const registryTemplateCacheKey = (modelId: Model['id']): string =>
  scopedTemplateKey(getRegistryRequestScope(), modelId);

/** Unscoped entries cannot safely represent a caller-dependent response. */
export const lookupRegistryTemplate = (
  templates: Record<string, T_Maybe<Template>>,
  modelId: Model['id']
): T_Maybe<Template> => templates[registryTemplateCacheKey(modelId)];
